import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-regular-svg-icons'
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons"

export default function Star({ filled }) {
    return filled ? <FontAwesomeIcon icon={solidStar} color="var(--cta-background)" /> : <FontAwesomeIcon icon={faStar} color="var(--cta-background)"/>
}